import { toast } from 'react-toastify';
import { HistoryViewItemLevel, historyPayloadType } from '../models/history';
import agent from '../api/agent';
import { makeAutoObservable, runInAction } from 'mobx';
import { store } from './store';
import {
  FilesFolderType,
  activeOrderType,
  assignUserType,
  cutlistDetailsType,
  circuitType,
  itemDeleteDetailsType,
  metadataType,
  HFCmetadataType,
  nfaiPDF2CSVtype,
  physicalAssetsType,
  HFCphysicalAssetsType,
} from '../api/types';
import { itemDetailsType } from '../api/types';
import sendRespectiveEmail from '../models/EmailNew';
import { AxiosResponse } from 'axios';
import { ElementIdListTypes } from './NFAI_Restoration_Smartflow/types';

export default class ViewStore {
  //view page history variables
  historyDetails: HistoryViewItemLevel[] = [];
  historyDetailsCount: number = 0;
  historyLoader: boolean = false;

  //view page assign user variables
  assignedUsers: assignUserType[] = [];
  unAssignUserLoader: boolean = false;
  unAssignedUsers: assignUserType[] = [];
  unAssignedUsersCount: number = 0;

  //view page details
  itemDetails: itemDetailsType = {
    id: '',
    title: '',
    type: '',
    element: '',
    current_task: '',
    current_subtask: '',
    status: '',
    current_user: '',
    asset_In_Vault: '',
    parent: '',
    thumbnail: '',
    preview: '',
    proxy: '',
    registerId: '',
  };

  HFCphysicalAssets : HFCphysicalAssetsType = {
   id: "",
  title: "",
  assetId: "",
  container_Barcodes: "",
  reel_Barcodes: "",
  vault:"",
  room: "",
  aisle_No: "",
  shelf: "",
  asset_In_Vault: "",
  movement_Time:""
  }

  //view page physical assets
  physicalAssets: physicalAssetsType = {
    id: '',
    physical_sensor_NFC: '',
    physical_sensor_barcode: '',
    physical_sensor_qrcode: '',
    physical_sensor_RFID: '',
    physical_location_rack: '',
    physical_location_shelf: '',
    physical_location_vault: '',
    global_positioning_system: '',
    asset_In_Vault: '',
    movement_Time: '',
  };

 

  //view page active order
  activeOrderLoader: boolean = false;
  activeOrder: activeOrderType = {
    templateId: '',
    templateIndex: 0,
    templateName: '',
    templateDateTime: '',
    isActive: false,
    isDeleted: false,
    tasks: [],
  };

  //view page technical metadata
  technicalMetadata: metadataType[] = [];

  //view page metadata
  metadata: metadataType[] = [];

  HFCmetaData: HFCmetadataType[] = [];

  //view page files
  itemFiles: FilesFolderType[] = [];

  //allowReelAnalysis or allowRestoration NFAI
  allowStart: string = '';

  //allow PDF report upload under physical for NFAI
  allowReelPDF: string = '';

  //NFAI reel details from PDF
  reelTemplateDetails: nfaiPDF2CSVtype = {
    reels: [],
    itemGroupId: '',
    typeId: '',
    typeName: '',
    elementId: '',
    elementName: '',
    departmentId: '',
    departmentName: '',
    templateId: '',
    excelPath: '',
  };

  cutlistDetails: cutlistDetailsType = {
    reelData: [],
    assetTypeId: '',
    assetTypeName: '',
    elementId: '',
    elementName: '',
    templateId: '',
  };
  
  cutlistDetailsLoader:boolean = false;

  hfcPhysical: { physicalCaseCount: number; pigeonHole: string } = {
    physicalCaseCount: 0,
    pigeonHole: '',
  };

  circuitDetails: circuitType[] = [];

  NFAIApisettings: {
    imageRestoration: any[];
    NFAI_AVSyn_Remarks: any[];
  } = {
    imageRestoration: [],
    NFAI_AVSyn_Remarks: [],
  };

  NFAIReportReelAnalysisReport:string[]=[];
  NFAIReportCutlistCheck:boolean=false;
  NFAIReportParentLinkStatus:string = '';
  NFAIReportRoleBasedUserList:any[]=[];


  // PDF2CSV NFAI-Restoration
  Pdf2CsvLoader:boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  //view page history functions starts
  viewPageHistory = async (params: {
    itemId: string;
    pageNo: number;
    pageSize: number;
  }) => {
    try {
      let {
        itemId = store.activityStore.selectedActivity?.id,
        pageNo = 1,
        pageSize = 4,
      } = params;
      this.historyLoader = false;
      const [historyResponse, countResponse] = await Promise.all([
        agent.viewPage.viewHistory({
          itemId,
          pageNo,
          pageSize,
        }),
        agent.viewPage.viewHistoryCount({ itemId }),
      ]);
      this.historyLoader = true;
      runInAction(() => {
        let tempHistory = [...historyResponse.data];
        tempHistory?.forEach((data: any) => {
          if (
            data?.dateTime !== undefined &&
            typeof data?.dateTime !== 'number'
          ) {
            let datas = new Date(data?.dateTime);
            datas = new Date(
              datas.getTime() - datas.getTimezoneOffset() * 60000,
            );
            data.dateTime = datas.toString();
          }
        });
        tempHistory?.sort((a: any, b: any) => {
          return b.time - a.time;
        });
        this.historyDetails = tempHistory;
        this.historyDetailsCount = countResponse.data;
      });
      this.historyLoader = false;
    } catch (error) {
      this.historyLoader = false;
      toast.error('Failed to load History Details & count.');
      console.log(
        'API /MediaAssets/history /MediaAssets/historyCount Failed: ',
        error,
      );
    }
  };

  viewPageHistoryAlone = async (params: {
    itemId: string;
    pageNo: number;
    pageSize: number;
  }) => {
    try {
      let {
        itemId = store.activityStore.selectedActivity?.id,
        pageNo = 1,
        pageSize = 4,
      } = params;
      this.historyLoader = false;
      const historyResponse = await agent.viewPage.viewHistory({
        itemId,
        pageNo,
        pageSize,
      });
      this.historyLoader = true;
      runInAction(() => {
        let tempHistory = [...historyResponse.data];
        tempHistory?.forEach((data: any) => {
          if (
            data?.dateTime !== undefined &&
            typeof data?.dateTime !== 'number'
          ) {
            let datas = new Date(data?.dateTime);
            datas = new Date(
              datas.getTime() - datas.getTimezoneOffset() * 60000,
            );
            data.dateTime = datas.toString();
          }
        });
        tempHistory?.sort((a: any, b: any) => {
          return b.time - a.time;
        });
        this.historyDetails = tempHistory;
      });
      this.historyLoader = false;
    } catch (error) {
      this.historyLoader = false;
      toast.error('Failed to load History Details.');
      console.log('API /MediaAssets/history Failed: ', error);
    }
  };

  viewPageHistoryCountAlone = async (params: { itemId: string }) => {
    try {
      let { itemId = store.activityStore.selectedActivity?.id } = params;
      this.historyLoader = false;
      const countResponse = await agent.viewPage.viewHistoryCount({ itemId });
      this.historyLoader = true;
      runInAction(() => {
        this.historyDetailsCount = countResponse.data;
      });
      this.historyLoader = false;
    } catch (error) {
      this.historyLoader = false;
      toast.error('Failed to load History Count.');
      console.log('API /MediaAssets/historyCount Failed: ', error);
    }
  };
  //view page history functions ends

  //view page assign user functions starts
  getAssignedUsers = async (params: { itemId: string }) => {
    try {
      const response = await agent.viewPage.assignedUsersList(params);
      runInAction(() => {
        this.assignedUsers = response?.data;
      });
    } catch (error) {
      toast.error('Failed to load assigned users list');
      console.log('API /MediaAssets/assignedUser Failed: ', error);
    }
  };

  getUnAssignedUsers = async (params: {
    itemId: string;
    displayName: string;
    pageNo: number;
    pageSize: number;
  }) => {
    try {
      this.unAssignUserLoader = true;
      const [response, countResponse] = await Promise.all([
        agent.viewPage.unAssignedUsersList(params),
        agent.viewPage.unAssignedUsersCount({
          itemId: params.itemId,
          displayName: params.displayName,
        }),
      ]);
      runInAction(() => {
        this.unAssignedUsers = response?.data;
        this.unAssignedUsersCount = countResponse?.data;
        this.unAssignUserLoader = false;
      });
    } catch (error) {
      this.unAssignUserLoader = false;
      toast.error('Failed to load unassigned users list & count');
      console.log(
        'API /MediaAssets/unAssignedUser /MediaAssets/unAssignedUserCount Failed: ',
        error,
      );
    }
  };

  getUnAssignedUsersAlone = async (params: {
    itemId: string;
    displayName: string;
    pageNo: number;
    pageSize: number;
  }) => {
    try {
      const response = await agent.viewPage.unAssignedUsersList(params);
      runInAction(() => {
        this.unAssignedUsers = response?.data;
      });
    } catch (error) {
      toast.error('Failed to load unassigned users list');
      console.log('API /MediaAssets/unAssignedUser Failed: ', error);
    }
  };

  getUnAssignedUsersCount = async (params: {
    itemId: string;
    displayName: string;
  }) => {
    try {
      const countResponse = await agent.viewPage.unAssignedUsersCount(params);
      runInAction(() => {
        this.unAssignedUsersCount = countResponse?.data;
      });
    } catch (error) {
      toast.error('Failed to load unassigned users count');
      console.log('API /MediaAssets/unAssignedUserCount Failed: ', error);
    }
  };

  addUserToItem = async (
    params: { itemId: string; userId: string },
    userName: string,
    NFAIaddUserCondition: boolean,
  ) => {
    try {
      const response = await agent.viewPage.addUserToItem(params);
      runInAction(async () => {
        if (response?.data?.includes('successfully assigned')) {
          //history update
          await store.commonStore.updateHistoryAlonePOST(
            `${store.userStore.user?.displayName} assigned user "${userName}" to ${this.itemDetails?.title}`,
            params.itemId,
            undefined,
            false,
          );
          //toast message
          toast.success('User successfully assigned to item.');
          //send mail
          sendRespectiveEmail('created', '', 'Added User', '');
          //update data in view under item page
          if (NFAIaddUserCondition) {
            this.getItemDetails({ itemId: params.itemId });
          }
          this.viewPageHistory({
            itemId: params.itemId,
            pageNo: 1,
            pageSize: 4,
          });
        } else {
          toast.error(response?.data);
        }
      });
    } catch (error) {
      toast.error('Failed to add user to item');
      console.log('API /MediaAssets/addUser Failed: ', error);
    }
  };

  removeUserFromItem = async (
    params: { itemId: string; userId: string },
    userName: string,
  ) => {
    try {
      const response = await agent.viewPage.removeUserFromItem(params);
      runInAction(async () => {
        if (response.data.includes('successfully removed')) {
          //history update
          await store.commonStore.updateHistoryAlonePOST(
            `${store.userStore.user?.displayName} removed user "${userName}" from ${this.itemDetails?.title}`,
            params.itemId,
            undefined,
            false,
          );
          //toast message
          toast.success('User successfully removed from item.');
          //send mail
          sendRespectiveEmail('deleted', '', `Removed User ${userName}`, '');
          //update data in view under item page
          this.getItemDetails({ itemId: params.itemId });
          this.viewPageHistory({
            itemId: params.itemId,
            pageNo: 1,
            pageSize: 4,
          });
        }
      });
    } catch (error) {
      toast.error('Failed to remove user from item');
      console.log('API /MediaAssets/removeUser Failed: ', error);
    }
  };
  //view page assign user functions ends

  //view page details function starts
  getItemDetails = async (params: { itemId: string }) => {
    try {
      const response = await agent.viewPage.itemDetailsAlone(params);
      runInAction(() => {
        this.itemDetails = response.data;
      });
    } catch (error) {
      toast.error('Failed to load item details');
      console.log('API /MediaAssets/details Failed: ', error);
    }
  };
  //view page details function ends

  //view page physical assets function starts
  getPhysicalAssets = async (params: { itemId: string }) => {
    try {
      const response = await agent.viewPage.physicalAssets(params);
      runInAction(() => {
        this.physicalAssets = response.data;  
      });
    } catch (error) {
      toast.error('Failed to load physical assets');
      console.log('API /MediaAssets/physicalAsset Failed: ', error);
    }
  };

  getHFCPhysicalAssets = async (params: { itemId: string }) => {
    try {
      const response = await agent.viewPage.HFCphysicalAssets(params);
      runInAction(() => {
        this.HFCphysicalAssets = response.data;  
      });
    } catch (error) {
      toast.error('Failed to load physical assets');
      console.log('API /MediaAssets/physicalAsset Failed: ', error);
    }
  };
  //view page physical assets function starts

  //view page active order function starts
  getActiveOrder = async (params: { itemId: string }) => {
    try {
      this.activeOrderLoader = true;
      const response = await agent.viewPage.activeOrder(params);
      runInAction(() => {
        if (response.data.templateId) {
          this.activeOrder = response.data;
        } else {
          this.resetActiveOrder();
        }
        this.activeOrderLoader = false;
        store.mediaAssetStore.mediaAsset.subtaskCompleteDetails = {
          isLoading: false,
          id: '',
        };
      });
      return response.data.templateId;
    } catch (error) {
      this.activeOrderLoader = false;
      toast.error('Failed to load active order');
      console.log('API /MediaAssets/activeOrder Failed: ', error);
    }
  };

  resetActiveOrder = () => {
    this.activeOrder = {
      templateId: '',
      templateIndex: 0,
      templateName: '',
      templateDateTime: '',
      isActive: false,
      isDeleted: false,
      tasks: [],
    };
  };
  //view page active order function ends

  //view page workflow update function starts
  workFlowProcessChangesUpdate = async (payload: {
    itemId: string;
    currentTask: string;
    currentSubtask: string;
    resolveSubtaskId: string;
    actionerName: string;
    status: number;
  }) => {
    try {
      const response = await agent.viewPage.workFlowProcessChanges(payload);
  
      if (response.data && response.data.result === 'Successfully Updated') {
        if (response.data.compTask !== 0) {
          await this.prodCountUpdate(response.data);
        }
    await this.getItemDetails({ itemId: payload.itemId });
    await this.getActiveOrder({ itemId: payload.itemId });
      }
    } catch (error) {
      toast.error('Task Update failed. Please try again.');
      console.log('API /MediaAssets/WorkflowProcessChange Failed: ', error);
    }
  };
  

  NFAIworkFlowProcessChangesUpdate = async (NFAIpayload: {
    itemId: string,
    templateId:string,
    currentTaskId:string,
    nextTaskId: string,
    currentSubtaskId: string,
    nextSubTaskId:string,
    actionerName: string,
    totalTask:number,
    afterRejectSubtaskName: string
  }) => {
    try {
      const response = await agent.viewPage.NFAIworkFlowProcessChanges(NFAIpayload);
     
      if (response) {
        await this.getActiveOrder({ itemId: NFAIpayload.itemId });
        await this.getItemDetails({ itemId: NFAIpayload.itemId });
      }
    } catch (error) {
      toast.error('Task Update failed. Please try again.');
    }
  };

  prodCountUpdate = async (payload: {
    itemId: string;
    prodCount: number;
    tolTask: number;
    compTask: number;
    result: string;
  }) => {
    try {
      await agent.viewPage.prodCount(payload);
      runInAction(() => {
        toast.success('Production count updated');
      });
    } catch (error) {
      toast.error('Production count failed to update');
      console.log('API /MediaAssets/prodPlanCount Failed: ', error);
    }
  };
  //view page workflow update function ends

  //view page technical metadata function starts
  getTechnicalMetadata = async (params: { itemId: string }) => {
    try {
      const response = await agent.viewPage.technicalMetaData(params);
      runInAction(() => {
        if (response?.data?.length > 0) {
          this.technicalMetadata = response?.data;
        } else {
          this.technicalMetadata = [];
        }
      });
    } catch (error) {
      toast.error('Failed to get Technical metadata');
      console.log('API /MediaAssets/technical Failed: ', error);
    }
  };
  //view page technical metadata function ends

  //view page parent metadata function starts
  parentMetadata = async (params: { itemId: string }) => {
    try {
      const response = await agent.viewPage.getParentMetaData(params);
      runInAction(() => {
        if (response?.data?.length > 0) {
          this.metadata = response?.data;
        } else {
          this.metadata = [];
        }
      });
    } catch (error) {
      toast.error('Failed to get Metadata');
      console.log('API /MediaAssets/metadata Failed: ', error);
    }
  };

  hfcMetadata = async (params: { itemId: string }) => {
    try {
      const response = await agent.viewPage.getHFCMetadata(params);
      runInAction(() => {
        if (response?.data?.length > 0) {
          this.HFCmetaData = response?.data;
        } else {
          this.HFCmetaData = [];
        }
      });
    } catch (error) {
      toast.error('Failed to get Metadata');
      console.log('API /MediaAssets/metadata Failed: ', error);
    }
  };
  //view page parent metadata function ends

  //view page item files function starts
  getItemPageFilesStructure = async (params: { itemId: string }) => {
    try {
      const response = await agent.viewPage.itemFiles(params);
      runInAction(() => {
        if (response?.data?.length > 0) {
          this.itemFiles = response?.data;
        } else {
          this.itemFiles = [];
        }
      });
    } catch (error) {
      toast.error('Failed to get item files');
      console.log('API /MediaAssets/files Failed: ', error);
    }
  };
  //view page item files function ends

  //view page item history update function starts
  addHistory = async (
    params: { itemId: string },
    payload: historyPayloadType,
    noToast?: boolean,
    noRefresh?: boolean,
  ) => {
    try {
      const response = await agent.viewPage.updateHistory(params, payload);
      runInAction(async () => {
        if (response.data.includes('successfully')) {
          if (!noToast) {
            if (response.status === 200) {
              toast.success('History updated');
            } else {
              toast.error('History update failed');
            }
          }
          if (!noRefresh) {
            await store.viewStore.viewPageHistory({
              itemId: params.itemId,
              pageNo: 1,
              pageSize: 4,
            });
          }
        }
      });
    } catch (error) {
      if (!noToast) {
        toast.error('Failed to update history');
      }
      console.log('API /MediaAssets/addHistory Failed: ', error);
    }
  };
  //view page item history update function ends

  //manage asset page delete item function begins
  confirmItemDelete = async (
    params: { itemId: string },
    masterReportsId?: string,
    afterHandler?: any,
  ) => {
    try {
      let itemDetailsForDelete: AxiosResponse<itemDeleteDetailsType>;
      const p1 = new Promise(async (resolve, reject) => {
        itemDetailsForDelete =
          await agent.manageAssetPage.itemDeleteDetails(params);
        if (itemDetailsForDelete.data) {
          resolve('');
        } else {
          reject('');
        }
      });
      p1.then(async () => {
        const deletedResponse = await agent.manageAssetPage.itemDelete(
          itemDetailsForDelete.data,
        );
        if (deletedResponse.data) {
          for (const [key, value] of Object.entries(deletedResponse.data)) {
            if (key !== '' && value !== true) {
              toast.error('Some parts of item were not deleted.');
            }
          }
        }
      });
      p1.then(() => {
        if (masterReportsId) {
          setTimeout(() => {
            store.WorkLevelStore.loadWorkLevelWithItem(masterReportsId);
          }, 300);
        }
      });
      p1.then(() => {
        setTimeout(() => {
          afterHandler?.();
        }, 400);
      });
      p1.catch(() => {
        toast.error('Something went wrong while deleting item');
      });
      return false;
    } catch (error) {
      toast.error('Failed to delete item');
      console.log('API /MediaAssets/item Failed: ', error);
    }
  };
  //manage asset page delete item function ends

  //check if start allowed in parent asset for NFAI
  allowStartNFAI = async (params: { itemId: string }, subTaskName: string) => {
    try {
      let response: AxiosResponse<string>;
      if (subTaskName === 'NFHM Reel Analysis QC') {
        response = await agent.NFAI.allowReelAnalysis(params);
      } else {
        response = await agent.NFAI.allowRestoration(params);
      }
      runInAction(() => {
        if (response?.data?.includes('Okay')) {
          this.allowStart = '';
        } else {
          this.allowStart =
            subTaskName === 'NFHM Reel Analysis QC'
              ? 'This Sub Task cannot be started since Reel Analysis is not yet completed for every Reel.'
              : 'This Sub Task cannot be started since Restoration is not fully completed.';
        }
      });
    } catch (error) {
      toast.error('Failed to check start condition NFAI');
      console.log('API Failed: ', error);
    }
  };

  //Reel Analysis PDF upload or not check
  allowReelPDFuploadCheck = async (params: { itemId: string }) => {
    try {
      const response = await agent.NFAI.allowReelPDFupload(params);
      runInAction(() => {
        if (!response.data?.includes('Need to upload file')) {
          this.allowReelPDF = response.data;
        } else {
          this.allowReelPDF = '';
        }
      });
    } catch (error) {
      toast.error('Failed to check reel file upload condition NFAI');
      console.log('API Failed: ', error);
    }
  };

  //convert NFAI PDF for reel to CSV
  nfaiPDF2CSV = async (params: { ItemId: string; path: string }) => {
    try {
     this.Pdf2CsvLoader = true;
      const response = await agent.NFAI.nfaiPDF2CSV(params);
      runInAction(() => {
        const filteredAssetId = this.metadata.filter((e)=> e.elementName === 'Asset ID')[0]?.elementId;
        const filteredInputFormat = this.metadata.filter((e)=> e.elementName === 'Input Format/Medium')[0]?.elementId;
        const filteredDeliveryFormat = this.metadata.filter((e)=> e.elementName === 'Delivery Format/Medium')[0]?.elementId;
        const filteredFilmElement = this.metadata.filter((e)=> e.elementName === 'Film Element')[0]?.elementId;
        const filteredFilmType = this.metadata.filter((e)=> e.elementName === 'Film Type')[0]?.elementId;
        const filteredFilmGauge = this.metadata.filter((e)=> e.elementName === 'Film Gauge')[0]?.elementId;
        const element:ElementIdListTypes = {
          AssetId : filteredAssetId || '',
          InputFormat: filteredInputFormat,
          DeliveryFormat: filteredDeliveryFormat,
          FilmElement: filteredFilmElement,
          FilmType: filteredFilmType,
          FilmGauge: filteredFilmGauge,
        }
        this.UpdateAssetIDUpdate(element,response.data.excelPath,params.ItemId);
        if (typeof response.data === 'string') {
          this.resetReelTemplateDetails();
          toast.info(response.data);
        } else {
          this.reelTemplateDetails = response.data;
        }
      });
      this.Pdf2CsvLoader = false;
    } catch (error) {
      toast.error('Failed to convert NFAI PDF to CSV');
      console.log('API Failed: ', error);
      this.Pdf2CsvLoader = false;
    }
  };

  //create Reel Items
  createReelItem = async (
    params: { itemGroupId: string; itemId: string },
    payload: any,
  ) => {
    try {
      await agent.NFAI.createReelItem(params, payload);
      runInAction(() => {
        toast.success(`${payload.title} created successfully.`);
      });
    } catch (error) {
      toast.error('Failed to create reel items');
      console.log('API Failed: ', error);
    }
  };

  //count update in inventory and production after reel creation for NFAI
  countUpdatePostReelCreation = async (params: {
    reelCount: number;
    taskCount: number;
  }) => {
    try {
      await agent.NFAI.countUpdatePostReelCreation(params);
    } catch (error) {
      toast.error('Failed to update count in Dashboard. Please contact Admin.');
      console.log('API Failed: ', error);
    }
  };

  resetReelTemplateDetails = () => {
    this.reelTemplateDetails = {
      reels: [],
      itemGroupId: '',
      typeId: '',
      typeName: '',
      elementId: '',
      elementName: '',
      departmentId: '',
      departmentName: '',
      templateId: '',
      excelPath: '',
    };
  };

  //cutlist creation in NFAI
  getCutlistDetails = async (params: { parentId: string }) => {
    try {
      this.cutlistDetailsLoader = true;
      const response = await agent.NFAI.getCutList(params);
      runInAction(() => {
        if (response.data.templateId) {
          this.cutlistDetails = response.data;
        }
      this.cutlistDetailsLoader = false;
      });
    } catch (error) {
      this.cutlistDetailsLoader = false;
      toast.error('Failed to get cutlist details');
      console.log('API Failed: ', error);
    }
  };

  getHFCPhysical = async (params: { itemId: string }) => {
    try {
      const response = await agent.HFC.getHFCPhysical(params);
      runInAction(() => {
        if (!isNaN(response.data.physicalCaseCount)) {
          this.hfcPhysical = response.data;
        } else {
          this.hfcPhysical = {
            physicalCaseCount: 0,
            pigeonHole: response.data.pigeonHole || '',
          };
        }
      });
    } catch (error) {
      toast.error('Failed to get Physical Case Count');
      console.log('API Failed: ', error);
    }
  };

  getCircuitDetails = async (params: {
    itemId: string;
  }) => {
    try {
      const response = await agent.HFC.getCircuit(params);
      runInAction(() => {
        if (response.data.length > 0) {
          this.circuitDetails = response.data;
        } else {
          this.circuitDetails = [];
        }
      });
    } catch (error) {
      toast.error('Failed to get Circuit Details');
      console.log('API Failed: ', error);
    }
  };

  deleteCircuit = async (params: { itemId: string }) => {
    try {
      await agent.HFC.deleteCircuit(params);
      runInAction(() => {
        toast.success('Circuit deleted successfully.');
      });
    } catch (error) {
      toast.error('Failed to delete circuit');
      console.log('API Failed: ', error);
    }
  };
  updateApisettingsValue(value: any, condition: string) {
    condition === 'imageRestoration'
      ? (this.NFAIApisettings.imageRestoration = value)
      : (this.NFAIApisettings.NFAI_AVSyn_Remarks = value);
  }
  UpdateAssetIDUpdate = async(element:ElementIdListTypes,path:string,itemId:string)=>{
    try {
      await agent.NFAIReport.AssetIDUpdate(element.AssetId,path);
      await agent.NFAIReport.InputFormatUpdate(element.InputFormat,path);
      await agent.NFAIReport.deliveryFormatUpdate(element.DeliveryFormat,path);
      await agent.NFAIReport.filmElementUpdate(element.FilmElement,path);
      await agent.NFAIReport.filmTypeUpdate(element.FilmType,path);
      await agent.NFAIReport.filmGaugeUpdate(element.FilmGauge,path);
      await this.parentMetadata({itemId})
    } catch (error) {
      console.log(error)
    }
  }
   HandleCutlistReelAnaylsis = async (parentId:string,name?:string) => {
     try {
      if(name === 'smartFlow'){
        await this.getItemDetails({itemId:parentId});
        parentId = this.itemDetails.parent?.split('/')[0] || ''
      }
      const parentDetails = await agent.viewPage.itemDetailsAlone({itemId:parentId});
      const response = await agent.viewPage.activeOrder({itemId : parentDetails.data?.parent?.split('/')[0] || ''});
      const currentTask =   await response.data?.tasks.filter((element: any) => element.taskName === "Final Restoration")[0].subTasks.filter((subtask:any)=> subtask.subTaskName === "Reel Analysis")[0].subTaskstatus === 2 ;
     runInAction(() => {
     this.NFAIReportCutlistCheck = !currentTask || false;
     return !currentTask || false;
     })
     } catch (error) {
       toast.error('Failed to get Cutlist Reel Analysis');
       console.log('API Failed: ', error);
   }
  }
    HandleParentLinkStatus = async(itemId:string)=>{
      try {
        const response = await agent.NFAIReport.getParentLinkStatus(itemId);
        runInAction(()=>{
          this.NFAIReportParentLinkStatus  = response.data;
        })
      } catch (error) {
        console.log(error)
      }
    }
    HandleRoleBasedUserList = async()=>{
      try {
        const response = await agent.NFAIReport.getRoleBasedUserList();
        runInAction(()=>{
          this.NFAIReportRoleBasedUserList  = response.data;
        })
      } catch (error) {
        console.log(error)
      }
    }
    HandleReelCreationUpdate = (data:any) =>{
      try {
        this.reelTemplateDetails.reels = data;
      } catch (error) {
        console.log(error);
      }
    }
}
